import qs from 'query-string';

import { nextApiAuthServiceInstance } from '~/domains/services/nextApi.instance';

import type { APISection } from '../common/sections/types';
import type { APIField } from '../common/fields/types/main';
import type { QueryParams } from '../common/api/settings/types/query.params';

type SectionsResponse = {
  sections: APISection[];
};

export const getEditNew = async (contestId: string) => {
  const response = await nextApiAuthServiceInstance.get<SectionsResponse>('/contest/edit/new', {
    params: { contestId },
  });

  return response.data?.sections ?? [];
};

export const getEditEndpointData = async <
  R extends APIField | APIField[] | APISection | APISection[],
>(
  endpoint: string,
  payload: Record<string, any>,
  method: 'GET' | 'POST' = 'GET',
  abortController?: AbortController,
  queryParams?: QueryParams
): Promise<R> => {
  const queryString = `?${qs.stringify(queryParams)}`;

  const response = await nextApiAuthServiceInstance.request<R>({
    url: `/contest/edit/${endpoint}${queryString}`,
    signal: abortController?.signal,
    method,
    ...(method === 'GET'
      ? {
          params: payload,
        }
      : {
          data: payload,
        }),
  });

  return response.data;
};

export const postEditContest = async (payload: Record<string, unknown>, contestId: string) => {
  const response = await nextApiAuthServiceInstance.post('/contest/edit/new', payload, {
    params: { contestId },
  });

  return response.data;
};
